import { render, staticRenderFns } from "./ImageLink.vue?vue&type=template&id=ebaa00dc&scoped=true&"
import script from "./ImageLink.vue?vue&type=script&lang=js&"
export * from "./ImageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa00dc",
  null
  
)

export default component.exports